export const stateFilters = {
    all: 'Select Status',
    open: 'Open',
    closed: 'Closed',
    ready: 'Ready',
    trashed: 'Trashed',
};

export const DISABLED_DELIVERY_RANGE = [3400, 3450];



// WEBPACK FOOTER //
// ./src/app/orders/constants.js